export default "__VITE_ASSET__FFsmhuVi__"